import z from "zod";

export const schema = z.object({
  name: z.string().regex(/^[a-zA-Z0-9_]+$/, {
    error: "Use letters, numbers, underscore",
  }),
});

export type Fields = z.infer<typeof schema>;
